/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogGdprRequestDto } from '../../models/log-gdpr-request-dto';

export interface ShopifyAppControllerLogGdprRequest$Params {

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
      body: LogGdprRequestDto
}

export function shopifyAppControllerLogGdprRequest(http: HttpClient, rootUrl: string, params: ShopifyAppControllerLogGdprRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'id'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerLogGdprRequest.PATH, 'post');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'id'?: string;
      }>;
    })
  );
}

shopifyAppControllerLogGdprRequest.PATH = '/api/v1/shopify-app/gdpr-requests';
